
import { put, takeLatest } from 'redux-saga/effects';
import SendRequest from '../../../shared/services/sendRequest.service';
import actionTypes from '../../types/outPatientTypes';
import * as actions from '../../actions/outPatientAction';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';

function* outPatientSaga(data: any): Generator {
  const sendRequest = SendRequest.instance;

  const { payload: { filterPageIndex, frontDeskSearch, pageIndex, pageRange } } = data;
  let request = {};
  let enteredValue = '';
  let key = '';
  if (frontDeskSearch) {
    const splittedData = frontDeskSearch.split('$$');
    enteredValue = splittedData && splittedData.length && splittedData[0];
    key = splittedData && splittedData.length && splittedData[1];
  }
  if (enteredValue && key) {
    request = {
      requestParameterDetail: {
        [key]: enteredValue.trimEnd(),
      },
      paginationBasedRequestDetail: {
        pageNumber: filterPageIndex,
        recordsPerPage: pageRange,
      },
      fetchNextActions: true,
    };
  } else {
    request = {
      providerRequestDetail: {
        providerIds: [
          10311,
        ],
      },
      paginationBasedRequestDetail: {
        pageNumber: pageIndex,
        recordsPerPage: pageRange,
      },
      fetchNextActions: true,
    };
  }

  try {
    const response: any = yield sendRequest.post<any, any>
      (`${GLOBAL_URL.CRM_OUTPATIENT_URL}Provider/FetchAllAppointments`, request);
    yield put(actions.frontDeskData(response));
    return;
  } catch (e) {
    yield put(actions.frontDeskData({}));
  }
}

function* frontDeskActionSaga(data: any): Generator {
  const sendRequest = SendRequest.instance;
  const { payload: { requestId, rescheduleDate, remarks, statusId, nextStatus, getData } } = data;

  const request = {
    requestId,
    currentStatusId: statusId,
    nextStatus,
    scheduledAppointmentDate: rescheduleDate,
    remarks,
  };
  try {
    const response: any = yield sendRequest.post<any, any>
      (`${GLOBAL_URL.CRM_OUTPATIENT_URL}Provider/AppointmentStatusUpdate`, request);
    getData(response);
    return;
  } catch (e) { }
}

export function* watchOutPatientAction(): any {
  yield takeLatest(actionTypes.OUTPATIENT_DETAILS, outPatientSaga);
  yield takeLatest(actionTypes.FRONTDESK_ACTION, frontDeskActionSaga);
}

export default watchOutPatientAction;
